export const CORONA_COMPANY_ID = 581404;

/**
 * Identifica ofertas generadas por Corona: a esas ofertas no se les
 * permite contraofertar, solo aceptar. Por eso el botón "Contraoferta"
 * se oculta cuando el cliente de la oferta es Corona.
 */
export function isCoronaOfferCompany(idCompany) {
  return idCompany === CORONA_COMPANY_ID;
}
